<ui-card [loading]="isLoading">
    <div class="ui" *ngIf="applicant">
        <div class="flex">
            <app-segment-header title="{{ 'applicant-tracker.applicants.recruiting' }}"> </app-segment-header>
        </div>

        <div class="margin-bottom-3">
            <h5 class="text-dark font-medium">{{ 'applicant-tracker.applicants.jobPosting' | appTranslate }}</h5>
            <a
                uiLink
                [routerLink]="['/recruiting/jobPostings/' + applicant?.jobPosting?.id + '/information']"
                class="icon font-size-medium"
                target="_blank"
            >
                {{ applicant?.jobPosting?.title }}
                <mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon>
            </a>
        </div>

        <h5 class="text-dark font-medium">{{ 'applicant-tracker.applicants.hiringTeam' | appTranslate }}</h5>
        <app-inline-avatars *ngIf="managerAssignmentsEmployees.length > 0" [employees]="managerAssignmentsEmployees">
        </app-inline-avatars>
        <p *ngIf="managerAssignmentsEmployees.length === 0">
            {{ 'applicant-tracker.applicants.noMembersAddedYet' | appTranslate }}
        </p>

        <div *ngIf="applicants.length">
            <mat-accordion class="job-posting-section">
                <mat-expansion-panel
                    class="mat-expansion-panel-without-border"
                    (opened)="isOtherJobOpportunitiesExpanded = true"
                    (closed)="isOtherJobOpportunitiesExpanded = false"
                >
                    <mat-expansion-panel-header class="mat-expansion-panel-header-without-padding">
                        <mat-panel-title class="other-job-opportunities-title"
                            >{{ 'applicant-tracker.applicants.otherJobOpportunities' | appTranslate }}
                            <ng-container>
                                <span class="counter margin-left-2">{{ applicants.length }}</span>
                            </ng-container>
                        </mat-panel-title>
                        <ui-button type="ghost">{{
                            (isOtherJobOpportunitiesExpanded ? 'collapse' : 'show') | appTranslate
                        }}</ui-button>
                    </mat-expansion-panel-header>

                    <p class="text-dark margin-bottom-2">
                        {{
                            {
                                key: 'applicant-tracker.applicants.viewApplicantfullNamesOtherJobOpportunitiesFor',
                                params: { name: applicant?.fullName },
                            } | appTranslate
                        }}
                    </p>

                    <div class="app-grid margin-top-1 margin-bottom-2" *ngFor="let applicant of applicants">
                        <a
                            uiLink
                            [routerLink]="['/recruiting', 'applicants', applicant?.id]"
                            target="_blank"
                            class="columns-6"
                            >{{ applicant.jobPosting.title }}</a
                        >
                        <div class="columns-6 text-align-left text-dark">
                            <ng-container class="margin-left-1"
                                >{{ applicant.jobFunnel?.funnelStep | appTranslateOptions: jobFunnelDisplay }}
                            </ng-container>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</ui-card>
